import { render, staticRenderFns } from "./string_field.vue?vue&type=template&id=2f60e5d7&scoped=true&lang=pug&"
import script from "./string_field.vue?vue&type=script&lang=js&"
export * from "./string_field.vue?vue&type=script&lang=js&"
import style0 from "./string_field.vue?vue&type=style&index=0&id=2f60e5d7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f60e5d7",
  null
  
)

export default component.exports